import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Articolo } from '../../models/articolo';
import { Catalogo } from '../../models/catalogo';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';
import { formatNumber } from "@angular/common";

@Component({
  selector: 'app-addarticolo',
  templateUrl: './addarticolo.component.html',
  styleUrls: ['./addarticolo.component.css'],

})
export class AddarticoloComponent implements OnInit {



  udms=[{ Nome: 'Kg'}, { Nome: 'm'}, { Nome: 'Ore'}];
  ivas=[{ Valore: 4}, { Valore: 5}, { Valore: 10}, { Valore: 22}];
  articolo: Articolo=new Articolo();
  hide = true;
//  selectedCatalogo:string='';
//  selectedUnitadimisura:string='';
//  selectedIva:number=0;

  cataloghi: Catalogo[];
  catalogo: Catalogo;
  rc:number;
  usertoedit: boolean;
  IPAddress:string;
  Port:string;
  Protocol:string;
  //pwd:string='';
  //confermaPwd:string='';

  selectedFile: File;
  retrievedImage: any;
  base64Data: any;
  retrieveResonse: any;
  imageName: any;
  registerForm: FormGroup;
  submitted = false;
  imagehaschanged=false;

  public message =  sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {
      if (environment.address.isLocal){
        this.IPAddress=environment.address.localIP;
        this.Port=environment.address.localPort;
        this.Protocol=environment.address.localProtocol;
      }else{
        this.IPAddress=environment.address.remoteIP;
        this.Port=environment.address.remotePort;
        this.Protocol=environment.address.remoteProtocol;
      }
    }

  ngOnInit(): void {
    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
            selectedValueCatalogo:['', Validators.required],
            selectedValueUnitamisura: [''],
            selectedValueIva: ['0'],
            Id: ['0', Validators.required],
            Codicecatalogo: ['0'],
            Codicearticolo: ['', Validators.required],
            Descrizione: ['', Validators.required],
            Categoria: [''],
            Unitamisura: [''],
            Costo: ['0',[Validators.pattern('^[0-9]*\.?[0-9]{1,2}$'), Validators.required]],
            Iva: ['0',Validators.required],
            Prezzo: ['0',[Validators.pattern('^[0-9]*\.?[0-9]{1,2}$'), Validators.required]],
            Note: [''],
            Giacenza: ['0',Validators.pattern('^[0-9]*\.?[0-9]{0,2}$')],
          });
    }

    this.commonService.getAllCataloghi().subscribe((res) => {
        this.cataloghi = res;
        if (this.commonService.selectedArticolo!=undefined){
          this.articolo=this.commonService.selectedArticolo;
          this.getImage(this.articolo.Codicearticolo);
          this.commonService.selectedArticolo=undefined;

          this.cataloghi.forEach(element => {
            if (element.Codice === this.articolo.Codicecatalogo){
              this.articolo.Catalogo=element;
//              this.selectedCatalogo=element.Nome;
            }
          });

          this.udms.forEach(element => {
            if (element.Nome === this.articolo.Unitamisura){
              this.articolo.Unitamisura=element.Nome;
  //            this.selectedUnitadimisura=element.Nome;
            }
          });

          this.ivas.forEach(element => {
            if (element.Valore === this.articolo.Iva){
              this.articolo.Iva=element.Valore;
  //            this.selectedIva=element.Valore;
            }
          });


        }else{
          this.articolo=new Articolo();
          if (this.commonService.selectedCatalogo!=undefined){
            this.catalogo=this.commonService.selectedCatalogo;
            this.articolo.Catalogo=this.catalogo;
            this.cataloghi.forEach(element => {
              if (element.Codice === this.articolo.Codicecatalogo){
                this.articolo.Catalogo=element;
              }
            });
          }
        }
  //      const formatted = formatNumber(this.articolo.Costo, "en", "1.2-2")
  //      alert(formatted);
  //      this.articolo.Costo = Number(formatted);
        this.aggiornaForm();
      });

  }
get f() { return this.registerForm.controls; }

manageChangeCosto(value:any){
    if (isNaN(value.target.value)){
      value.target.value=this.articolo.Costo;
    }else{
      this.articolo.Costo=Number(value.target.value);
    }
    let p:number=this.articolo.Costo*(1+this.articolo.Iva/100);
    this.articolo.Prezzo=Number(p.toFixed(2));
    this.registerForm.patchValue({
      Costo:this.articolo.Costo,
      Prezzo:this.articolo.Prezzo,
    });
}
manageChangeIva(){
    if (isNaN(this.articolo.Costo)){
      return;
    }
    this.articolo.Iva= this.registerForm.value.selectedValueIva;
    this.articolo.Prezzo=this.articolo.Costo*(1+this.articolo.Iva/100);
    this.registerForm.patchValue({
      Costo:this.articolo.Costo,
      Iva:this.articolo.Iva,
      Prezzo:this.articolo.Prezzo,
    });
}
manageChangePrezzo(value:any){
    if (isNaN(value.target.value)){
      value.target.value=this.articolo.Prezzo;
    }else{
      this.articolo.Prezzo=Number(value.target.value);
    }
    this.registerForm.patchValue({
      Prezzo:this.articolo.Prezzo,
    });
}
manageChangeGiacenza(value:any){
    if (isNaN(value.target.value)){
      value.target.value=this.articolo.Giacenza;
    }else{
      this.articolo.Giacenza=Number(value.target.value);
    }
    this.registerForm.patchValue({
      Giacenza:this.articolo.Giacenza,
    });
}

aggiornaForm(){
  this.articolo.Giacenza=Number(this.articolo.Giacenza.toFixed(2));
  this.registerForm.setValue({
    selectedValueCatalogo:this.articolo.Catalogo.Nome,
    selectedValueUnitamisura:this.articolo.Unitamisura,
    selectedValueIva:this.articolo.Iva,
    Id:this.articolo.Id,
    Codicecatalogo:this.articolo.Catalogo.Codice,
    Codicearticolo:this.articolo.Codicearticolo,
    Descrizione:this.articolo.Descrizione,
    Categoria:this.articolo.Categoria,
    Unitamisura:this.articolo.Unitamisura,
    Costo:this.articolo.Costo,
    Iva:this.articolo.Iva,
    Prezzo:this.articolo.Prezzo,
    Note:this.articolo.Note,
    Giacenza:this.articolo.Giacenza
});
}

save() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{
            this.cataloghi.forEach(element => {
              if (this.registerForm.value.selectedValueCatalogo === element.Nome){
                this.registerForm.value.Codicecatalogo=element.Codice;
              }
            });
            this.udms.forEach(element => {
              if (this.registerForm.value.selectedValueUnitamisura === element.Nome){
                this.registerForm.value.Unitamisura=element.Nome;
              }
            });
            this.ivas.forEach(element => {
              if (this.registerForm.value.selectedValueIva === element.Valore){
                this.registerForm.value.Iva=element.Valore;
              }
            });

            this.commonService.saveArticolo(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo

              if (this.rc===-1){
                alert("Errore creazione articolo");
              }else if (this.rc===-2){
                alert("Errore per codice articolo duplicato");
              }else{
                  if (this.imagehaschanged){
                      this.addImageToArticolo(this.registerForm.value.Codicearticolo);
                  }else{
                    alert("Articolo salvato con successo");
                    this.router.navigate(['articoli']);
                  }
              }
            });

        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

  cancel(){
    this.commonService.selectedArticolo=null;
    this.router.navigate(['articoli']);
  }

  addImageToArticolo(articoloid:string){
    const uploadImageData = new FormData();
    if (this.selectedFile!=undefined){
      uploadImageData.append('imageFile', this.selectedFile, this.selectedFile.name);
    }else{
      uploadImageData.append('imageFile', new File([], '', { type: 'image/jpeg' }), '');
    }
    uploadImageData.append('articoloid', articoloid);

    //Make a call to the Spring Boot Application to save the image
      this.httpClient.post(this.Protocol+'://'+this.IPAddress+':'+this.Port+'/api/articolo/uploadImage', uploadImageData, { observe: 'response' })
        .subscribe((response) => {
          console.log("--->AddImage"+response.status.toString());
          if (response.status === 200) {
            alert("Articolo salvato con successo");
            this.imagehaschanged=false;
            this.router.navigate(['articoli']);
          } else {
            alert('Errore salvataggio immagine');
          }
        }
        );
    }


  public onFileChanged(files) {

    if (files.length === 0)
      return;
    var mimeType = files[0].type;
    if (files[0].size>50000){
      alert("Immagine troppo grande (max 50KB)");
    }else if (mimeType.match(/image\/*/) == null) {
        alert("Sono supportate solo immagini.");
    }else{
      var reader = new FileReader();
      const imagePath:any = files;
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
          this.retrievedImage = reader.result;
      }
      this.selectedFile = files[0];
      this.imagehaschanged=true;
    }
  }

  onUpload() {
    console.log(this.selectedFile);
    //FormData API provides methods and properties to allow us easily prepare form data to be sent with POST HTTP requests.

  }

getImage(codicearticolo:string) {
  this.httpClient.get(this.Protocol+'://'+this.IPAddress+':'+this.Port+'/api/articolo/picture/' + codicearticolo)
    .subscribe(
      res => {
        this.retrieveResonse = res;
        if (this.retrieveResonse!=null && this.retrieveResonse.Picbyte!=null){
          this.base64Data = this.retrieveResonse.Picbyte;
          this.retrievedImage = 'data:image/jpeg;base64,' + this.base64Data;
        }
      }
    );
  }

  removeImg(){
    //this.selectedFile=new File(null, "empty", { type: 'image/jpeg' });
    this.selectedFile=null;
    this.retrievedImage = null;
    this.imagehaschanged = true;
  }

  myFilter(d: Date): boolean {
  //		const selectinableday = d.getDay();
  //console.log("---->"+d);
    if(d!=undefined){
      const selectinablemonth = d.getMonth();
      const selectinableyear = d.getFullYear();
      const selectinableday = d.getDate();
      const todaysDateObject = new Date();
      const actualday = todaysDateObject.getDate();
      const actualmonth = todaysDateObject.getMonth();
      const actualyear = todaysDateObject.getFullYear();
      if (actualyear - 11> selectinableyear){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }

  getConfigurazione(){
    return configurazione.addarticolo;
  }

}
